// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Ensure it covers the full viewport height */
    background-color: hsla(150, 80%, 1%, 1);
    position: relative;
}

.Login-section {
    background-color: #333;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    width: 300px;
    height: 300px;
    /* Make it a square */
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    justify-content: center;
    /* Center the content vertically */
}

.Login-field {
    margin-bottom: 15px;
    width: 100%;
    /* Ensure the field takes full width */
}

.Login-field label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
    text-align: left;
    /* Align label text to the left */
    width: 100%;
    /* Ensure the label takes full width */
}

.Login-field input {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    /* Ensure padding is included in the width */
}

.Login-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease;
    width: 100%;
    /* Ensure the button takes full width */
}

.Login-button:hover {
    background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/css/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,8CAA8C;IAC9C,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".Login {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    /* Ensure it covers the full viewport height */\n    background-color: hsla(150, 80%, 1%, 1);\n    position: relative;\n}\n\n.Login-section {\n    background-color: #333;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    width: 300px;\n    height: 300px;\n    /* Make it a square */\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #fff;\n    justify-content: center;\n    /* Center the content vertically */\n}\n\n.Login-field {\n    margin-bottom: 15px;\n    width: 100%;\n    /* Ensure the field takes full width */\n}\n\n.Login-field label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: bold;\n    text-align: left;\n    /* Align label text to the left */\n    width: 100%;\n    /* Ensure the label takes full width */\n}\n\n.Login-field input {\n    width: 100%;\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-sizing: border-box;\n    /* Ensure padding is included in the width */\n}\n\n.Login-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 1rem;\n    transition: background-color 0.3s ease;\n    width: 100%;\n    /* Ensure the button takes full width */\n}\n\n.Login-button:hover {\n    background-color: #0056b3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
